import {
  CHANGE_PASSWORD_RESET,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FALIURE
} from './ChangePasswordConstants'

const intialstate = {
  is_loading : false,
  success_status : false,
  change_password : null,
  get_error : ''
}

const ChangePasswordReducers = (state = intialstate,action) =>{
  switch(action.type){
    case CHANGE_PASSWORD_RESET : return {
      ...state,
      is_loading: false,
      success_status: false,
      change_password: null,
      get_error: null
    }
    case CHANGE_PASSWORD_REQUEST : return {
      ...state,
      is_loading: true,
      success_status: false,
      change_password: null,
      get_error: null
    }
    case CHANGE_PASSWORD_SUCCESS : return {
      ...state,
      is_loading: false,
      success_status: true,
      change_password: action.payload
    }
    case CHANGE_PASSWORD_FALIURE : return {
      ...state,
      is_loading: false,
      success_status: false,
      get_error:action.payload
    }
    default: return state
  }

}

export default ChangePasswordReducers
